module.exports = __webpack_public_path__ + "img/doris.7e987716.svg";